import WETH from '~/components/WETH'

export default WETH
